import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import '../layouts/NavBar.scss';
import PFLogoSmall from '../assets/images/PFLogoSmall.png';
import dashboardNavImg from '../assets/images/dashboard-icon.svg';
import salesNavImg from '../assets/images/sales-icon.svg';
import reportsNavImg from '../assets/images/reportsNavWhite.png';
import mastersNavImg from '../assets/images/masters-icon.svg';
import usersNavImg from '../assets/images/user-icon.svg';
import dashboardNavBlue from '../assets/images/dashboardNavBlue.png';
import salesNavBlue from '../assets/images/salesNavBlue.png';
import reportsNavBlue from '../assets/images/reportsNavBlue.png';
import masterNavBlue from '../assets/images/masterNavBlue.png';
import usersNavBlue from '../assets/images/usersNavBlue.png';
import adminConfigNavImg from '../assets/images/admin-config-icon.svg';
import adminConfigNavBlue from '../assets/images/adminConfigBlue.png';
import othersNavImg from '../assets/images/othersNavWhite.png';
import othersNavBlue from '../assets/images/othersNavBlue.png';
import userImage from '../assets/images/userImage.png';
import settingsSvg from '../assets/images/settings.svg';
import avatar from '../assets/images/avatar.png';
import Profile from '../pages/Auth/Profile';
import useAuth from '../providers/authProvider';
import FetchData from '../providers/dataProvider';
import { isEmpty } from '../utils/Validate';
import Notification from '../components/common/Notification';
import support from '../assets/images/support-icon.svg';
import logoutIcon from '../assets/images/logout-icon.svg'
import settingsicon from '../assets/images/settings-icon.svg'
import { useNavigate, navigate } from "react-router-dom";
import urls from "../constants";

const NavBar = () => {
    const { logout } = useAuth();
    const location = useLocation();
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const navigate = useNavigate();
    const [menuList, setMenuList] = useState(null)
    const [parentMenu, setparentMenu] = useState(null)
    // const [unreadCount, setUnreadCount] = useState(0);

    const userProfile = JSON.parse(localStorage.getItem("userProfile"));

    if (location.pathname === '/forgot-password') return null;

    const menuAccess = FetchData("menupermissions", { applicationCode: urls.APPLICATION_CODE });

    useEffect(() => {
        const rawResponse = menuAccess?.data;
        const resolvedMenuList =
            (Array.isArray(rawResponse?.data) && rawResponse.data) ||
            (Array.isArray(rawResponse?.menus) && rawResponse.menus) ||
            (Array.isArray(rawResponse) && rawResponse) ||
            [];
        setMenuList(resolvedMenuList);
    }, [menuAccess])

    useEffect(() => {
        if (menuList) {
            let parentMenu = menuList.filter(function (data) {
                return data.menuParentId === 0 && data.isParent === true
            })

            parentMenu = [...parentMenu].sort((a, b) => a.sequence - b.sequence);

            setparentMenu(parentMenu)
        }
    }, [menuList])

    const getmenuurl = (menuname) => {
        let childurl = "#"
        if (menuname === "Enquiry") childurl = "/enquiry-list"
        if (menuname === "Quotation") childurl = "/quotation"
        if (menuname === "Order") childurl = "/order-list"
        if (menuname === "Factory Order") childurl = "/factory-order-list"
        if (menuname === "Company Master") childurl = "company-master"
        if (menuname === "Distributor Master") childurl = "/distributor-master"
        if (menuname === "Customer Master") childurl = "/customer-master"
        if (menuname === "Project Master") childurl = "/project-master"
        if (menuname === "Facility Master") childurl = "/facility-master"
        if (menuname === "Delivery Terms") childurl = "/delivery-terms"
        if (menuname === "Payment Terms") childurl = "/payment-terms"
        if (menuname === "General Master") childurl = "/general-master"
        if (menuname === "Role Permission") childurl = "/role-management"
        if (menuname === "User Master") childurl = "/user-master"
        if (menuname === "Multiplier Master") childurl = "/multiplier-master"
        if (menuname === "Approval Master") childurl = "/approval-master"
        if (menuname === "Dashboard") childurl = "/dashboard"
        if (menuname === "Multiplier Master") childurl = "/add-new-multiplier"
        return childurl;
    }

    const isRouteActive = (menuName) => {
        const targetUrl = getmenuurl(menuName);
        if (!targetUrl || targetUrl === "#") return false;
        return location.pathname === targetUrl || location.pathname.startsWith(`${targetUrl}/`);
    };

    const ImageHover = (image, menuname) => {
        if (window.document.getElementById(menuname)) window.document.getElementById(menuname).innerHTML = "<img src=" + image + " className='mr-2'></img>" + menuname
    }

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    useEffect(() => {
        document.documentElement.style.setProperty(
            "--sidebar-width",
            sidebarCollapsed ? "76px" : "224px"
        );

        return () => {
            document.documentElement.style.setProperty("--sidebar-width", "224px");
        };
    }, [sidebarCollapsed]);

    useEffect(() => {
        if (!parentMenu) return;

        const activeParent = parentMenu.find((menu) => {
            const childMenu = menu.subMenus || [];
            return isRouteActive(menu.menuName) || childMenu.some((child) => isRouteActive(child.menuName));
        });

        if (activeParent) setOpenMenu(activeParent.menuId);
    }, [location.pathname, parentMenu]);

    return (
        <div className='path-finder-nav-bar'>
            <nav>
                {!sidebarOpen && (
                    <button
                        className="mobile-menu-btn"
                        onClick={() => setSidebarOpen(true)}
                    >
                        <i className="fas fa-bars"></i>
                    </button>
                )}
                <div className={`sidebar ${sidebarOpen ? "open" : ""} ${sidebarCollapsed ? "collapsed" : ""}`}>
                    <div className="logo sidebar-logo text-center">
                        <Link to="/dashboard" title="Dashboard">
                            <img src={PFLogoSmall} alt="Path Finder" />
                        </Link>
                        <button
                            type="button"
                            className="sidebar-collapse-btn"
                            onClick={() => setSidebarCollapsed((currentValue) => !currentValue)}
                            title={sidebarCollapsed ? "Expand menu" : "Collapse menu"}
                            aria-label={sidebarCollapsed ? "Expand menu" : "Collapse menu"}
                        >
                            <i className={`fas ${sidebarCollapsed ? "fa-angle-right" : "fa-angle-left"}`}></i>
                        </button>
                    </div>
                    <input type="radio" name="slider" id="menu-btn" />
                    <input type="radio" name="slider" id="close-btn" />
                    <button
                        className="close-sidebar"
                        onClick={() => setSidebarOpen(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                    <ul className="nav-links">
                        {/* <label for="close-btn" class="btn close-btn"><i class="fas fa-times"></i></label> */}
                        {parentMenu?.map((menu, index) => {
                            if (menu?.menuName === "Reports" || menu?.menuName === "Others") return;
                            const childMenu = menu.subMenus || [];
                            const childAscending = [...childMenu].sort((a, b) => a.sequence - b.sequence);
                            let tagimage = ""
                            let tagimagehover = ""

                            if (menu?.menuName === "Dashboard") {
                                tagimage = dashboardNavImg
                                tagimagehover = dashboardNavBlue
                            }
                            if (menu?.menuName === "Sales") {
                                tagimage = salesNavImg
                                tagimagehover = salesNavBlue
                            }
                            if (menu?.menuName === "Reports") {
                                tagimage = reportsNavImg
                                tagimagehover = reportsNavBlue
                            }
                            if (menu?.menuName === "Masters") {
                                tagimage = mastersNavImg
                                tagimagehover = masterNavBlue
                            }
                            if (menu?.menuName === "Admin Config") {
                                tagimage = adminConfigNavImg
                                tagimagehover = adminConfigNavBlue
                            }
                            if (menu?.menuName === "Users") {
                                tagimage = usersNavImg
                                tagimagehover = usersNavBlue
                            }
                            if (menu?.menuName === "Others") {
                                tagimage = othersNavImg
                                tagimagehover = othersNavBlue
                            }

                            const isParentActive =
                                isRouteActive(menu?.menuName) ||
                                childAscending.some((child) => isRouteActive(child?.menuName));

                            return (
                                <li className="pb-70 mr-3 cursor-pointer" key={menu.menuId}>
                                    <div
                                        className={`desktop-item ${isParentActive ? "menu-active" : ""}`}
                                        title={menu.displayName || menu.menuName}
                                        onClick={() => {
                                            if (childAscending.length > 0) {
                                                if (sidebarCollapsed) {
                                                    setSidebarCollapsed(false);
                                                    setOpenMenu(menu.menuId);
                                                    return;
                                                }
                                                setOpenMenu(openMenu === menu.menuId ? null : menu.menuId);
                                            } else {
                                                navigate(getmenuurl(menu.menuName));
                                            }
                                        }}
                                    >
                                        <img src={tagimage} alt="" />
                                        <span>{menu.displayName || menu.menuName}</span>

                                        {childAscending.length > 0 && (
                                            <i
                                                className={`ml-auto fas ${openMenu === menu.menuId
                                                    ? "fa-chevron-up"
                                                    : "fa-chevron-down"
                                                    }`}
                                            />
                                        )}
                                    </div>
                                    {!sidebarCollapsed && openMenu === menu.menuId && childAscending.length > 0 && (
                                        <ul className="submenu-list">
                                            {childAscending.map((child) => {
                                                if (
                                                    ["RFQ", "Submittal", "Delivery & Invoice"].includes(
                                                        child.menuName
                                                    )
                                                )
                                                    return null;

                                                return (
                                                    <li className="p-0" key={child.menuId}>
                                                        <Link
                                                            to={getmenuurl(child.menuName)}
                                                            onClick={() => setActiveSubMenu(child.menuId)}
                                                            className={(activeSubMenu === child.menuId || isRouteActive(child.menuName)) ? "submenu-active" : ""}
                                                        >
                                                            {child.displayName || child.menuName}
                                                            {(activeSubMenu === child.menuId || isRouteActive(child.menuName)) && (
                                                                <i className="fa fa-chevron-right mr-2 submenu-icon"></i>
                                                            )}
                                                        </Link>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </li>
                            )
                        })}
                    </ul>
                    <div className="user-img">
                        <ul className='d-flex w-100'>
                            <li className="sidebar-footer d-flex flex-column">
                                <Link
                                    to="#"
                                    data-toggle="modal"
                                    data-target="#profileRightSideModalPopup"
                                    className="sidebar-footer-item profile-item"
                                    title="Profile"
                                >
                                    <img src={avatar} alt="User" className="mr-2 usr-img" />
                                    <span>Profile</span>
                                </Link>

                                <Link to="/settings" className="sidebar-footer-item" title="Settings">
                                    <img src={settingsicon} alt="settings" className="mr-2" />
                                    <span>Settings</span>
                                </Link>

                                <Link to="/support" className="sidebar-footer-item" title="Support">
                                    <img src={support} alt="Support" className="mr-2" />
                                    <span>Support</span>
                                </Link>
                                <button
                                    type="button"
                                    className="sidebar-footer-item logout-btn"
                                    onClick={logout}
                                    title="Logout"
                                >
                                    <img src={logoutIcon} alt="Logout" className="mr-2" />
                                    <span>Logout</span>
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* <label for="menu-btn" class="btn menu-btn mt-1"><i class="fas fa-bars"></i></label> */}

                </div>
                {sidebarOpen && (
                    <div
                        className="sidebar-overlay"
                        onClick={() => setSidebarOpen(false)}
                    />
                )}
            </nav>
            {/* <!-- profileRightSideModalPopup start--> */}
            <Profile />
        </div >
    )
}

export default NavBar